import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Avatar from '../Avatar';

const UserImage = ({ isSelected, picture, classes }) => {
    if (isSelected) {
        return (
            <Avatar className={classes.iconAvatar}>
                <i className="material-icons">check</i>
            </Avatar>
        );
    }

    return <Avatar alt="user-image" src={picture} />;
};

UserImage.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    picture: PropTypes.string.isRequired,
};

const style = ({ palette }) => ({
    iconAvatar: {
        background: palette.primary.main,
    },
});

export default injectSheet(style)(UserImage);



// WEBPACK FOOTER //
// ./src/components/users/UserImage.js